import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from './axiosBaseQuery'
import { baseUrl } from './axiosInstance'

const audienceApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl
  }),
  reducerPath: 'audienceApi',
  tagTypes: [
    'audience',
    'country',
    'province',
    'district',
    'taluka',
    'village',
    'crop'
  ],
  endpoints: () => ({})
})

export default audienceApi
